import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { JobStatusTypes } from 'src/app/models/enum/job-status-types.enum';
import { Job } from 'src/app/models/job.model';
import { MassCompletionOtherAssets } from 'src/app/models/mass-completion-other-assets.model';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import { JobEta } from 'src/app/models/job-eta.model';
import { JobService } from 'src/app/services/sections/job/job.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { ButtonIcons } from '../../action-button/models/button-icons.enum';
import { ActionsPlaceholderSettings } from 'src/app/models/enum/actions-placeholder-settings.enum';
import { SettingsPreferences } from 'src/app/services/ui/models/settings-preferences.model';
import { PageType } from 'src/app/models/enum/page-type.enum';
import { BitwiseHelper } from 'src/app/services/helpers/bitwise.helper';


@Component({
	templateUrl: './change-eta.component.html',
	styleUrls: ['./change-eta.component.scss', '../../stylesheets/job-actions.scss', '../../stylesheets/job-main.scss', '../../stylesheets/job-inputs.scss']
})
export class ChangeEtaComponent implements OnInit, AfterViewInit {

	public formModel: FormGroup;

	public readonly ButtonIcons = ButtonIcons;
	public readonly ActionsPlaceholderSettings = ActionsPlaceholderSettings;
	public readonly PageType = PageType;
	public readonly BitwiseHelper = BitwiseHelper;

	public self = this;
	public job: Job;
	public pageType: PageType;
	public customerPreferences: SettingsPreferences;
	public isLoading = false;
	public additionalAssets: MassCompletionOtherAssets;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private jobService: JobService
	) { }

	public get isJobFlowDone() {
		return [JobStatusTypes.Completed, JobStatusTypes.Canceled].includes(this.job.statusId);
	}

	public get isActionAvailable(): boolean {
		return !this.customerPreferences?.preferences.isJobAutoSkipped &&
			!(this.pageType === PageType.Customer &&
				this.customerPreferences?.preferences.isNotificationDisabled
			);
	}

	ngOnInit(): void {

		this.job = (this.activatedRoute.snapshot.data.jobDetails || {}) as Job;
		this.customerPreferences = this.activatedRoute.snapshot.data.customerPreferences as SettingsPreferences;
		this.pageType = this.activatedRoute.snapshot.data.pageType;

		if (this.job && !this.isJobFlowDone) {
			GlobalSettingsService.isSecondaryLoaderLoading = true;
			this.isLoading = true;
			this.jobService.getOtherAssets(TokenHelper.getToken(this.activatedRoute))
				.subscribe(assets => {
					this.additionalAssets = assets;
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					this.isLoading = false;
				}, () => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					this.isLoading = false;
				});
		}
		else {
			GlobalSettingsService.isSecondaryLoaderLoading = false;
			this.isLoading = false;
		}
		this.formModel = new FormGroup({
			currentDate: new FormControl({ value: new Date(this.job.jobEta), disabled: true }),
			newDate: new FormControl(null, [Validators.required]),
			comment: new FormControl(null, [Validators.required, Validators.minLength(10), Validators.pattern(/\S+/)]),
			additionalAssets: new FormControl([])
		});

	}

	ngAfterViewInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
	}

	public submitEtaChange(): void {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		const model = this.formModel.getRawValue();

		const offset = model.newDate.getTimezoneOffset();
		model.newDate = new Date(model.newDate.getTime() - (offset * 60 * 1000));

		const payload: JobEta = {
			collectedOn: model.newDate.toISOString().split('T')[0],
			result: model.comment,
			serial: this.job.serial,
			additionalAssets: model.additionalAssets
		};

		this.jobService.changeJobEta(this.activatedRoute.snapshot.paramMap.get('token'), payload)
			.subscribe(
				() => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					this.job.jobEta = moment(model.newDate).parseZone().format('MM/DD/YYYY');
					this.router.navigate(['../'], { relativeTo: this.activatedRoute });
				},
				() => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
				});
	}

	public onOtherAssetChange(assetState: any, assetId: number): void {
		const selectedAssets = this.formModel.get('additionalAssets').value;
		if (assetState.checked) {
			selectedAssets.push(assetId);
		}
		else {
			const index = selectedAssets.indexOf(assetId, 0);
			selectedAssets.splice(index, 1);
		}

		this.formModel.patchValue({
			selectedAssets
		});
	}

}
